module.exports = __webpack_public_path__ + "img/stop_btn.38e59530.png";